module.exports = __webpack_public_path__ + "static/media/sqsSa_sm6.f2880ed3.png";